export default "__VITE_ASSET__0baa217e__"